module.exports = __webpack_public_path__ + "84824aa5c7e834aecbd34830fbff1d0a.pdf";